import axios from "src/lib/axios";

export const getThailandAddress = async () => {
  const { data: response } = await axios.get("/static/address");
  return response?.data;
};
